<div class="stsdocs-page-header">
    <h2 class="stsdocs-page-header-title">Clients</h2>
</div>

<div *ngIf="!loading" class="stsdocs-page-body">
    <div fxLayout fxLayoutAlign="center center" class="stsdocs-tabs-header">
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="selectedTabChange($event)" animationDuration="0ms" mat-align-tabs="center" mat-stretch-tabs>
            <mat-tab *ngFor="let tab of tabs" [label]="tab.label"></mat-tab>
        </mat-tab-group>
    </div>

    <div *ngIf="tabs[selectedIndex]" class="stsdocs-tabs-body">
        <div class="stsdocs-tabs-body-content">
            <markdown *ngIf="tabs[selectedIndex].contentType === 'markdown'" [src]="tabs[selectedIndex].content"></markdown>

            <object *ngIf="tabs[selectedIndex].contentType === 'iframe'" type="text/html" class="stsdocs-iframe" style="color-scheme: light !important;" [data]="tabs[selectedIndex].content"></object>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <p>Loading...</p>
</div>
